<div class="modal-body license-framework-notice-modal-body">
    <div class="modal-header">
        <div class="title-container">
            <span class="lato-22-b-vw title-text">
                <ng-container *ngIf="licensedFrameworksCount > 1">
                    {{ licensedFrameworksCount }} FRAMEWORKS ADDITION
                </ng-container>
                <ng-container *ngIf="licensedFrameworksCount <= 1 && frameworkName">
                    {{ frameworkName }} FRAMEWORK ADDITION
                </ng-container>
            </span>
        </div>
        <div class="close-icon" cygovSvgIcon [svgName]="'x-icon-type2'"
            (click)="setModalResult(false)">
        </div>
    </div>

    <div class="modal-content-body">
        <div class="lato-16-n-vw message">
            By enabling {{ licensedFrameworksCount > 1 ? 'these ' + licensedFrameworksCount + '
            frameworks' : 'this framework' }},
            you confirm that your organization holds {{ licensedFrameworksCount > 1 ? `valid
            licenses or authorizations to use them` : `a valid license or authorization to use it`
            }}.
            Centraleyes provides tooling and automation only, and does not provide or sublicense any
            rights to the underlying framework content.
            <br>
            Centraleyes is not responsible for any use of frameworks without the appropriate
            licenses.
        </div>

        <div class="lato-16-n-vw delete-confirm">
            Type the word <span class="confirm-txt" (click)="copyToClipboard('confirm')"
                style="cursor: pointer;">&nbsp;"confirm"&nbsp;</span> to enable
            <input [(ngModel)]="confirmationString" type="text" class="delete-input" />
        </div>

        <div class="modal-content-footer">
            <div class="d-flex justify-content-center">
                <cygov-button class="button-margin" [buttonText]="'CONFIRM'" [buttonWidth]="'6vw'"
                    [buttonHeight]="'3.5vh'" [buttonColor]="'#29a9eb'" [hoverColor]="'#0F92E3'"
                    [disableClick]="isConfirmDisabled()"
                    [ngClass]="{'disable-click': isConfirmDisabled()}"
                    (click)="!isConfirmDisabled() && setModalResult(true)">
                </cygov-button>
                <cygov-button class="button-margin" [buttonText]="'CANCEL'" [buttonWidth]="'6vw'"
                    [buttonHeight]="'3.5vh'" [buttonColor]="'#030715'" [buttonBorder]="'#C5C9D1'"
                    [textColor]="'#C5C9D1'" (click)="setModalResult(false)">
                </cygov-button>
            </div>
        </div>
    </div>
</div>